import Swiper, {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper';

// import 'swiper/swiper.min.css';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

// class MvSwiper {
//   constructor(el) {
//     this.el = el
//     this.materDuration = 4000
//     this.mater  = document.getElementById('js-mater')
//     this.swiper = this._init()
//   }

//   _init() {
//     return new Swiper(this.el, {
//       modules: [Navigation, Pagination, Autoplay],
//       loop: true,
//       centeredSlides: true,
//       speed: 1000,
//       pagination: {
//         el: '.c-mv-swiper_num', // ページネーションとして認識させるクラス
//         // clickable: true, // ページネーションをクリックしたら移動する
//         // type: "fraction", //形のタイプ: bullets ドット型 | fraction 番号型 | custom カスタム
//         type: 'custom',
//         renderCustom: (mvSwiper, current, total) => {
//           return (
//             `<span class="_current">0&nbsp;${current}</span><span class="_total">0&nbsp;${total}</span>`
//           )
//         }    
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },  
//       on: {
//         slideChange: function() {
//           /**
//            - 1枚目のスライドはdelay:4000で切り替わりまで3秒。
//            - 2枚目からは delay:4000 + speed:1000 で4秒掛かることになるので
//            - 2枚目から delay:3000 に変更して4秒になるよう調整。
//            */
//           if (this.realIndex > 0) {
//             this.params.autoplay.delay = 3000;//4000-300
//             this.barDuration = 3000;
//           }
//         },
//         slideChangeTransitionStart: (result) => {
//           // スライド（次または前）へのアニメーションの開始時にイベント発生
//           this.mater.style.transitionDuration = '0s'
//           this.mater.style.transform = 'scaleX(0)'
//         },
//         slideChangeTransitionEnd: (result) => {
//           // スライド（次または前）へのアニメーションの開始後にイベント発生
//           this.mater.style.transitionDuration = this.materDuration + 'ms'
//           this.mater.style.transform = 'scaleX(1)'
//         },
//       }
//     })
//   }

//   start(options = {}) {
//     options = Object.assign({
//       delay: 4000,
//       disableOnInteraction: false,
//     }, options)

//     this.swiper.params.autplay = options
//     this.swiper.autoplay.start()
//   }
  
//   stop() {
//     this.swiper.autoplay.stop()
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const mvSwiper = new MvSwiper('.swiper')
//   setTimeout(() => {
//     mvSwiper.start({ delay: 1000 })
//   }, 1000)
// })

export class PersonalSlide {
  constructor() {
    this.personalSliders = document.querySelectorAll('.p-personal-slider')
    if (!this.personalSliders.length) { return } 

    this._init()
  }

  _init() {
    this.personalSliders.forEach(personalSlider => {
      const targetSlider     = personalSlider.querySelector('.swiper')
      const targetPagination = personalSlider.querySelector('.p-personal-slider_pagination')
      const options = {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: targetPagination,
        }
      }
    
      new Swiper(targetSlider, options)
    })
  }
}

export class HomeRentalSlide {
  constructor() {
    this.recommendSlide = document.querySelector('.js-recommend-slide')
    if (!this.recommendSlide) { return }

    this.recommendSlideContainer = this.recommendSlide.querySelector('.js-recommend-slide_container')
    this.recommendProgress       = this.recommendSlide.querySelector('.c-slide-progress .swiper-pagination')
    this.prev                    = this.recommendSlide.querySelector('.js-slide-btn_prev')
    this.next                    = this.recommendSlide.querySelector('.js-slide-btn_next')

    this._init()
  }

  _init() {
    const options = {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      autoplay: true,
      slidesPerView: 1.2,
      // centeredSlides: true,//1枚目のスライド中央配置
      navigation: {
        prevEl: this.prev,
        nextEl: this.next,
      },
      pagination: {
        el: this.recommendProgress,
        type: "progressbar",
      },
      breakpoints: {
        // 568px以上の場合
        568: {
          slidesPerView: 2.5,
        },
        // 768px以上の場合
        768: {
          slidesPerView: 2.7,
        }
      }
    }  
    new Swiper(this.recommendSlideContainer, options)
  }
}

